import React, { useState, useEffect } from "react";

function LinearProgressBar({
	label = "Linear Progress Bar",
	open = false,
	className,
}) {
	//   const [progress, setProgress] = useState(0);

	// Simulate progress increase over time (you can replace this with your actual progress logic)
	//   useEffect(() => {
	//     const interval = setInterval(() => {
	//       setProgress((prevProgress) => {
	//         const newProgress = prevProgress + 10;
	//         return newProgress <= 100 ? newProgress : 100;
	//       });
	//     }, 1000);

	//     return () => clearInterval(interval);
	//   }, []);

	return (
		<div className={`justify-center ${open ? "block" : "hidden"} ${className}`}>
			{label}
			<div className="w-full h-2 bg-gray-300 relative m-auto">
				<div
					className="h-full bg-blue-500 animate-pulse"
					// style={{ width: `${progress}%` }}
				></div>
			</div>
		</div>
	);
}

export default LinearProgressBar;
